import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo/luca.svg'


const _withScopeId = n => (_pushScopeId("data-v-440ce968"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0.293278 15.7853C0.0270118 15.5191 0.00280571 15.1024 0.22066 14.8088L0.293278 14.7247L6.76261 8.255L0.293278 1.78533C0.0270118 1.51906 0.00280571 1.1024 0.22066 0.808785L0.293278 0.724668C0.559545 0.458401 0.976209 0.434195 1.26982 0.652049L1.35394 0.724668L8.35394 7.72467C8.6202 7.99093 8.64441 8.4076 8.42656 8.70121L8.35394 8.78533L1.35394 15.7853C1.06105 16.0782 0.586172 16.0782 0.293278 15.7853Z",
  fill: "#707070"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "___default__side-menu bg-white h-screen fixed top-0 left-0 flex flex-col justify-between items-start border-r border-neutral-100" }
const _hoisted_4 = { class: "p-4 px-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "luca-education",
  title: "Luca Education",
  class: "logo",
  height: "50"
}, null, -1))
const _hoisted_6 = { class: "text-sm text-neutral-500 font-medium pl-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChooseCenter = _resolveComponent("ChooseCenter")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_SideMenu = _resolveComponent("SideMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ChooseCenter)
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", {
      class: _normalizeClass(["___default", 
			_ctx.sideActive && !_ctx.setup.store.state.sideBarisHide ? 'side--active' : ''
		])
    }, [
      (_ctx.sideActive)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "background fixed",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActive(false)))
          }, null, 512)), [
            [_vShow, !_ctx.setup.store.state.sideBarisHide]
          ])
        : _createCommentVNode("", true),
      (!_ctx.setup.store.state.sideBarisHide)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "draw-icon fixed",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActive(!_ctx.sideActive)))
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([{ 'rotate-180': _ctx.sideActive }, "transform h-4"]),
              width: "9",
              height: "17",
              viewBox: "0 0 9 17",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_2, 2))
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SideMenu, {
          onLogout: _ctx.logout,
          onChoose: _ctx.openModal
        }, null, 8, ["onLogout", "onChoose"]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.version), 1)
        ])
      ], 512), [
        [_vShow, !_ctx.setup.store.state.sideBarisHide]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["___default__content", { 'side-bar-hide': _ctx.setup.store.state.sideBarisHide }])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2)
    ], 2)
  ], 64))
}